export default function SVG_Marker() {
  return (
    <div>
      <h1>SVG_Marker Component</h1>
    </div>
  );
}
